/*
Usage:
requireAll(require.context(
  './modules', // path
  false, // recursive
  /\.js$/ // regex
));
Docs:
https://webpack.github.io/docs/context.html
*/
export default function requireAll(requireContext) {
    return requireContext.keys().map(requireContext);
}
